<template>
    <div class="row categoreiesCreate-block mt-4">
        <div class="col-xl-12 col-xxl-12 p-lr-0-sm">
            <div class="row multisteps-form">
                <div class="col-sm-12 col-md-7 col-lg-7 col-xl-8 col-xxl-7 p-lr-0-sm">
                    <form class="multisteps-form__form dis-flex flex-column" @submit.prevent>
                        <div class="card p-3 dis-flex flex-column mb-4 multisteps-form__content col-sm-12">
                            <div class="row">
                                <div class="col-sm-12 p-lr-0-sm">
                                    <div class="dis-flex col-12 p-0">
                                        <div class="col-7 p-0 dis-flex flex-m"><i class="uis uis-bars mr-2 text-rose"></i>
                                            <h5 class="text-sm-b">Create Category</h5>
                                        </div>
                                        <div class="col-5 p-0 ml-auto">
                                            <div class="uploaded-user-icon-show w-full dis-flex flex-m flex-r" v-if="createCategory.icon">
                                                <small class="text-success txt-italic mr-2">Uploaded icon -</small>
                                                <div class="any-category-user-icon" :style="{'background-image': `url(data:image/png;base64,${createCategory.icon})`}"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-8 col-lg-7 p-lr-0-sm mt-3">
                                            <div class="col-sm-12 p-0 dis-flex">
                                                <div class="col-9 col-lg-10 p-0">
                                                    <div class="dis-flex flex-m flex-sb multisteps-form__content">
                                                        <label>Name</label>
                                                        <div class="btn small-form-btn fs-10 pointer" title="Translations Languages">
                                                            <select class="translate-lang-swich pointer text-uppercase" name="translation-lang" @change="createCategory.selected_lang = $event.target.value">
                                                                <option v-for="(thisName, thisNameKey) in createCategory.name" :key="thisNameKey" :value="thisNameKey" :selected="createCategory.selected_lang == thisNameKey">{{ thisNameKey }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <template v-for="(thisName, thisNameKey) in createCategory.name" :key="thisNameKey">
                                                        <input v-if="createCategory.selected_lang == thisNameKey" class="multisteps-form__input form-control" type="text" placeholder="Category Name" v-model="createCategory.name[thisNameKey]">
                                                    </template>
                                                </div>
                                                <div class="col-3 col-lg-3 dis-flex flex-column flex-m pr-0">
                                                    <div class="dis-flex flex-m flex-sb multisteps-form__content">
                                                        <label class="mb-0">Icon</label>
                                                    </div>
                                                    <div class="pick-an-icon mt-auto pointer">
                                                        <label class="pointer" for="categoryIcon">
                                                            <i class="uis uis-scenery mr-2 fs-25 pointer"></i>
                                                        </label>
                                                        <input accept="image/png, image/jpeg" type="file" @change="uploadCategoryIcon($event)" id="categoryIcon">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-4 col-lg-5 dis-flex flex-column mt-auto p-0">
                                            <div class="col-sm-12 p-lr-0-sm dis-flex">
                                                <button class="btn button-create-atrb-btn ml-auto" type="button" title="Create Category" :disabled="!componentsAttributesIsAllNamesLength(createCategory.name, 3)" @click="createNewCategory()">Create</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-sm-12 col-md-5 col-lg-5 col-xl-4 col-xxl-5 p-lr-0-sm">
                    <div class="card multisteps-form__content p-3 dis-flex flex-column mb-4 max-h-c100-210vh">
                        <div class="dis-flex flex-m flex-sb col-12 p-0 mb-3">
                            <div class="dis-flex flex-m">
                                <i class="uis uis-bars mr-2 text-rose"></i>
                                <h5 class="text-sm-b">All Categoreies</h5>
                            </div>
                            <small class="text-rose txt-italic">Created</small>
                        </div>
                        <div class="content-crds-messages-scroll">
                            <div class="row mb-2" v-for="(thisCategory) in categoriesList" :key="thisCategory.id">
                                <div class="col-sm-12 p-lr-0-sm">
                                    <div class="bg-white-list">
                                        <div class="dis-flex flex-m flex-sb">
                                            <div class="dis-flex flex-m">
                                                <div class="mr-2 any-category-user-icon" v-if="thisCategory.icon" :style="{'background-image': `url(data:image/png;base64,${thisCategory.icon})`}"></div>
                                                <h5 class="text-sm-b">{{ componentsGetNormalName(thisCategory.name) }}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import componentsGetNormalName from '@/mixins/componentsGetNormalName.js'

export default {
    props: {
        categoriesList: {
            type: Array,
            required: true
        }
    },
    mixins: [componentsGetNormalName],
    data() {
        return {
            createCategory: {
                selected_lang: 'en',
                name: {},
                icon: null,
            }
        }
    },
    methods: {
        createNewCategory: function() {
            let thisNewCategoryData = JSON.parse(JSON.stringify(this.createCategory))
            let newCategoryData = {
                id: (Math.floor(Math.random() * 100000000) + 100000),
                name: thisNewCategoryData.name,
                icon: thisNewCategoryData.icon,
            }
            socket.emit('categories:createCategory', newCategoryData, (success) => {
                this.$emit('updateCategoryList')
            })
            this.categoriesList.push(newCategoryData)

            this.createCategory.selected_lang = 'en'
            this.createCategory.icon = null
            for (const key in this.createCategory.name) {
                this.createCategory.name[key] = ''
            }
        },
        componentsAttributesIsAllNamesLength: function(thisNameObj, minLength) {
            let allNameIsWithMinLength = true

            for (const key in thisNameObj) {
                const thisName = thisNameObj[key]
                if (thisName.length < minLength) {
                    allNameIsWithMinLength = false
                    break
                }
            }

            return allNameIsWithMinLength
        },
        uploadCategoryIcon: function(thisEvent) {
            let thisVue = this
            for (const key in thisEvent.target.files) {
                const thisNewImage = thisEvent.target.files[key]
                if (typeof thisNewImage != 'object') continue;
                else if (key == 'length') continue;
                else if (thisNewImage.type.indexOf('image') != 0) continue;

                const reader = new FileReader();
                reader.onload = function() {
                    const base64 = this.result.replace(/.*base64,/, '');
                    thisVue.createCategory.icon = base64
                };
                reader.readAsDataURL(thisNewImage);
                break;
            }
            thisEvent.target.value = ''
        }
    },
    watch: {
        '$store.state.languages': {
            handler: function(newLangObj, oldLangObj) {
                for (const key in newLangObj) {
                    if (!this.createCategory.name.hasOwnProperty(key)) {
                        this.createCategory.name[key] = ''
                    }
                }
            },
            deep: true
        }
    },
    mounted: function() {
        this.$emit('updateCategoryList')
        for (const key in this.$store.state.languages) {
            if (!this.createCategory.name.hasOwnProperty(key)) {
                this.createCategory.name[key] = ''
            }
        }
    }
}
</script>

<style>

</style>